import React, { Component } from "react";
import { Button, Spacer } from "@chakra-ui/react";
import ReactToPrint from 'react-to-print';


import ObservationLotReport from "./Reports/ObservationLotReport";
import ObservationStandardReport from "./Reports/ObservationStandardReport";
import ObservationGenericReport2 from "./Reports/ObservationGenericReport2";



export default class ReportNavigatorPage extends Component 
{
    constructor(props) 
    {
        super(props);
        //this.configService = new ConfigService();
        this.state = 
        {

        }
    }

    


    render()
    {
        var rptName = this.props.location.state.reportName.toLowerCase();
        var rpt;
        if (rptName === "observation-lot")
        {
            rpt =  <ObservationLotReport
            ref={(response) => (this.componentRef = response)} 
            onErrorPageRequest={this.props.onErrorPageRequest}
            onLoginExpire={this.props.onRequestLogout}
            onToastRequest={this.props.onToastRequest}
            userSession={this.props.userSession}
            onExpiredToken={this.props.onExpiredToken}

            observation={this.props.location?.state?.observation}
            observationId={this.props.location?.state?.observation?.identifiers?.id}
            reportName={this.props.location?.state?.reportName}
          />
        } else if (rptName === "observation-std")
        {
            rpt = <ObservationStandardReport

            ref={(response) => (this.componentRef = response)} 

            onErrorPageRequest={this.props.onErrorPageRequest}
            onLoginExpire={this.props.onRequestLogout}
            onToastRequest={this.props.onToastRequest}
            userSession={this.props.userSession}
            onExpiredToken={this.props.onExpiredToken}

            observation={this.props.location?.state?.observation}
            observationId={this.props.location?.state?.observation?.identifiers?.id}
            reportName={this.props.location?.state?.reportName}
        />
        }
        else 
        {
            rpt =  <ObservationGenericReport2

            ref={(response) => (this.componentRef = response)} 

            onErrorPageRequest={this.props.onErrorPageRequest}
            onLoginExpire={this.props.onRequestLogout}
            onToastRequest={this.props.onToastRequest}
            userSession={this.props.userSession}
            onExpiredToken={this.props.onExpiredToken}

            observation={this.props.location?.state?.observation}
            observationId={this.props.location?.state?.observation?.identifiers?.id}
            reportName={this.props.location?.state?.reportName}
        />
        }


        return (
            <span>
       
                <button className="btn btn-primary" onClick={(e) => this.props.onHomePageRequest(this.props.userSession.token)}>Home</button>&nbsp;
                <ReactToPrint
                    trigger = {() => <button className="btn btn-primary">Print</button>}
                    content = {()=>this.componentRef}
                />
                
     
                {rpt}

            </span>

        )
    }





}